// extracted by mini-css-extract-plugin
export default {"cls1":"CenteredDiv-cls1_CQT","cls2":"CenteredDiv-cls2_R32 CenteredDiv-cls1_CQT"};